import { render, staticRenderFns } from "./Curve.vue?vue&type=template&id=2c546c7d&scoped=true&"
import script from "./Curve.vue?vue&type=script&lang=js&"
export * from "./Curve.vue?vue&type=script&lang=js&"
import style0 from "./Curve.vue?vue&type=style&index=0&id=2c546c7d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c546c7d",
  null
  
)

export default component.exports